// extracted by mini-css-extract-plugin
module.exports = {"icon":"CartLink_icon__lb5b9","total":"CartLink_total___AfZz","control":"CartLink_control__dEP_h","controlActive":"CartLink_control-active__AhdOR"};